export default "__VITE_ASSET__CYt0TIH0__"